import React, { useEffect, useMemo } from "react";
import _ from "lodash";
import { SearchOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserPlus,
  faCloudUploadAlt,
  faCloudDownloadAlt,
  faSearchPlus,
} from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";
import { Button, Select, Form, Input, Row, Col, Tooltip, message } from "antd";
import { useGetHotelList } from "../../../hooks/hotel.hooks";

const { Option } = Select;

const UserManagerHeader = (props) => {
  const {
    hmgId,
    setHmgId,
    hotelId,
    setHotelId,
    search,
    setSearch,
    submitFn,
    isLoadingData,
    exportOnClick,
    initialDataLoad, 
    setInitialDataLoad,
  } = props;

  const { data: hotelData, isLoading: isLoadingHotels } = useGetHotelList({
    onError: (err) => {
      if (err.response) {
        const { errors } = err.response.data;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
      } else {
        message.error(err.message);
      }
    },
  });

  const history = useHistory();

  const sortedHmgList = useMemo(() => {
    return _.uniqBy(hotelData, "hmg_name").sort((a, b) =>
      a.hmg_name.localeCompare(b.hmg_name),
    );
  }, [hotelData]);
  const allHmgOptions = sortedHmgList.map((d) => (
    <Option key={d.hmg_name} value={d.hmg_id}>
      {d.hmg_name}
    </Option>
  ));

  const filterHotelData = (hmgIdValue) =>
    (hotelData ?? [])
      .filter((item) => {
        return hmgIdValue === "All"
          ? true
          : hmgIdValue && item.hmg_id === hmgIdValue;
      })
      .sort((a, b) => a.hotel_name.localeCompare(b.hotel_name));

  const sortedHotelList = useMemo(() => {
    return filterHotelData(hmgId);
  }, [hmgId]);

  const hotelOptions = useMemo(() => {
    return sortedHotelList.map((d) => (
      <Option key={d.hotel_id} title={`${d.hotel_code} - ${d.hotel_name}`}>
        {`${d.hotel_code} - ${d.hotel_name}`}
      </Option>
    ));
  }, [sortedHotelList]);

  useEffect(() => {
    if (initialDataLoad && sortedHmgList.length > 0) {
      setHmgId(sortedHmgList[0].hmg_id);
    }
  }, [initialDataLoad, sortedHmgList]);

  useEffect(() => {
    if (initialDataLoad && sortedHotelList[0]) {
      setHotelId(sortedHotelList[0].hotel_id);
    }
  }, [initialDataLoad, sortedHotelList]);

  useEffect(() => {
    if (initialDataLoad && hotelId) {
      setInitialDataLoad(false);
      submitFn();
    }
  }, [initialDataLoad, hotelId]);

  const hmgOnChange = (e) => {
    setHmgId(e);
    const filteredHotelData = filterHotelData(e);
    if (!Array.isArray(filteredHotelData)) {
      return;
    }
    if (filteredHotelData.length === 1) {
      setHotelId(filteredHotelData[0].hotel_id);
    } else {
      setHotelId("All");
    }
  };

  return (
    <div className="header_2">
      <div className="header_2_a">
        <div className="header_2_aa">
          <Form layout="vertical">
            <Row gutter={[16, 16]}>
              <Col xxl={8} xl={8} lg={8} md={6} sm={24} xs={24}>
                <Form.Item label="Hotel Management Group">
                  <Select
                    showSearch
                    // allowClear={true}
                    optionFilterProp="children"
                    notFoundContent={null}
                    placeholder="Hotel Management Group"
                    onChange={hmgOnChange}
                    value={hmgId}
                    loading={isLoadingHotels}
                    style={{ width: "100%" }}
                    disabled={isLoadingHotels || allHmgOptions.length === 1}
                  >
                    {allHmgOptions.length > 1 && (
                      <Option value="All">All</Option>
                    )}
                    {allHmgOptions}
                  </Select>
                </Form.Item>
              </Col>
              <Col xxl={8} xl={8} lg={8} md={6} sm={24} xs={24}>
                <Form.Item label="Hotel">
                  <Select
                    showSearch
                    // allowClear={true}
                    optionFilterProp="children"
                    notFoundContent={null}
                    placeholder="Hotel"
                    onChange={setHotelId}
                    value={hotelId}
                    disabled={!(hotelOptions.length > 1)}
                    style={{ width: "100%" }}
                  >
                    {hotelOptions.length > 1 && (
                      <Option value="All">All</Option>
                    )}

                    {hotelOptions}
                  </Select>
                </Form.Item>
              </Col>
              <Col xxl={6} xl={6} lg={6} md={6} sm={24} xs={24}>
                <Form.Item label="Search">
                  <Input
                    prefix={<SearchOutlined className="site-form-item-icon" />}
                    placeholder="Search"
                    allowClear
                    value={search}
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form.Item>
              </Col>

              <Col xxl={2} xl={2} lg={2} md={2} sm={24} xs={24}>
                <Form.Item label=" ">
                  <Button
                    type="primary"
                    onClick={submitFn}
                    loading={isLoadingData}
                    disabled={isLoadingHotels}
                  >
                    Go
                  </Button>
                </Form.Item>
              </Col>
              {/*
               */}
            </Row>
          </Form>
        </div>
      </div>
      <div className="header_2_b">
        <div className="header_2_ba">
          <div className="header_2_baa">
            <Tooltip placement="bottomLeft" title="Add New User">
              <Button
                onClick={() => history.push("/user-create")}
                type="link"
                size="large"
                icon={<FontAwesomeIcon className="anticon" icon={faUserPlus} />}
              />
            </Tooltip>
          </div>
          <div className="header_2_baa">
            <Tooltip placement="bottom" title="Import">
              <Button
                onClick={() => history.push("/bulk-user-creation")}
                type="link"
                size="large"
                icon={
                  <FontAwesomeIcon
                    className="anticon"
                    icon={faCloudUploadAlt}
                  />
                }
              />
            </Tooltip>
          </div>
          <div className="header_2_baa">
            <Tooltip placement="bottomRight" title="Export ">
              <Button
                onClick={exportOnClick}
                type="link"
                size="large"
                icon={
                  <FontAwesomeIcon
                    className="anticon"
                    icon={faCloudDownloadAlt}
                  />
                }
              />
            </Tooltip>
          </div>
          <div className="header_2_baa">
            <Tooltip placement="bottomRight" title="Advance Search ">
              <Button
                onClick={() => history.push("/advance-search/user")}
                type="link"
                size="large"
                icon={
                  <FontAwesomeIcon className="anticon" icon={faSearchPlus} />
                }
              />
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserManagerHeader;
